import "./App.css";
import Graph from "./components/ForceGraph";
import SCPPivotChart from "./components/SCPPivotChart";
import SCPRadarChart from "./components/SCPRadarChart";
import SCPPieChart from "./components/SCPPieChart";
import SCPBarChart from "./components/SCPBarChart";
import SCPAreaChart from "./components/SCPAreaChart";
import SCPLineChart from "./components/SCPLineChart";
import { Table } from "./components/SCPTable";
import SCPDefaultChart from "./components/SCPDefaultChart";
import { Styles, color } from "./components/SCPChartHelpers";
import "./components/css/AiTable.css";

function MainApp() {
  function unicodeToString(text) {
    return text.replace(/\\u[\dA-F]{4}/gi, function (match) {
      return String.fromCharCode(parseInt(match.replace(/\\u/g, ""), 16));
    });
  }
  const title = unicodeToString(
    document.getElementById("title").textContent.replace(/"/g, "")
  );
  const chartType = document.getElementById("type").textContent;
  const COLUMNS = JSON.parse(document.getElementById("COLUMNS").textContent);
  const jsonData = JSON.parse(document.getElementById("inputData").textContent);
  if (chartType.includes("networkGraph")) {
    return <Graph data={jsonData} title={title} />;
  } else if (chartType.includes("pivotChart")) {
    return <SCPPivotChart jsonData={jsonData} title={title} />;
  } else if (chartType.includes("radarChart")) {
    return <SCPRadarChart jsonData={jsonData} title={title} />;
  } else if (chartType.includes("pieChart")) {
    return <SCPPieChart jsonData={jsonData} title={title} />;
  } else if (
    chartType.includes("barChart") ||
    chartType.includes("barStackedChart")
  ) {
    return (
      <SCPBarChart jsonData={jsonData} title={title} chartType={chartType} />
    );
  } else if (
    chartType.includes("areaChart") ||
    chartType.includes("areaStackedChart")
  ) {
    return (
      <SCPAreaChart jsonData={jsonData} title={title} chartType={chartType} />
    );
  } else if (chartType.includes("lineChart")) {
    return <SCPLineChart jsonData={jsonData} title={title} />;
  } else if (chartType.includes("table")) {
    return (
      <div>
        <div className="chartTitle">{title}</div>
        <Styles>
          <Table columns={COLUMNS} data={jsonData} title={title} />;
        </Styles>
      </div>
    );
  } else {
    return <SCPDefaultChart jsonData={jsonData} title={title} />;
  }
}

export default MainApp;
